import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';

@Component({
  selector: 'custom-rating',
  templateUrl: './custom-rating.component.html',
  styleUrls: ['./custom-rating.component.scss'],
})

export class CustomRatingComponent implements OnInit {
  @ViewChild("maxStars") maxStars: number = 5;
  @Output() valueChange: EventEmitter<number> = new EventEmitter();

  selectedIndex: number = -1;
  focusedIndex: number = -1;
  maxArray: any;

  constructor() { }

  ngOnInit(): void {
    this.maxArray = new Array(this.maxStars);
  }

  mouseover(index: number){
    this.focusedIndex = index;
  }

  mouseout() {
    if(this.selectedIndex >= 0)
      this.focusedIndex = this.selectedIndex;
    else this.focusedIndex = -1;
  }

  onSelected(index: number): void {
    this.selectedIndex = index;
    this.valueChange.emit(index + 1);
  }
}
